import { IMSAggregator } from './aggregator';
import { mode } from 'app/shared/aggregators';
/**
 * @ngdoc service
 * @name ims.viewControllers.service:ModeAggregator
 * @description
 * The ModeAggregator is a service that returns the mode average of an array of stats or values.
 * It does also work on an array of strings, and returns the most common string.
 * Example data: 13, 18, 13, 14, 13, 16, 14, 21, 13
 * Example agg result: 13
 */

export class ModeAggregator extends IMSAggregator {
    constructor() {
        super();
        this.logicalName = 'mode';
        this.displayName = 'Avg (mode)';
    }

    /**
     * Takes in an array of values and returns an aggregate value.
     * Returns the mode of the value array.
     *
     * @param valueArray An array of values
     * @returns Number number or string value
     */
    getAggValueForValueArray(valueArray) {
        return mode(valueArray);
    }
}
